export default "__VITE_ASSET__BXdX2diR__"